import { render } from "./ModalMenuSetSchedule.vue?vue&type=template&id=001310b7&scoped=true"
import script from "./ModalMenuSetSchedule.vue?vue&type=script&lang=js"
export * from "./ModalMenuSetSchedule.vue?vue&type=script&lang=js"

import "./ModalMenuSetSchedule.vue?vue&type=style&index=0&id=001310b7&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001310b7"]])

export default __exports__